import { useState } from 'react';
import { testimonials } from '../../mocks/testimonials';

export default function SharedTestimonials() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-24 bg-[#0B2C26]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">Real Surfers. Real Repairs.</p>
          <h2 className="text-4xl md:text-5xl font-black text-white">
            Trusted by <span className="text-[#FF6B35]">40,000+ Surfers</span>
          </h2>
          <p className="text-stone-400 mt-3 max-w-lg mx-auto text-base">
            From reef cracks to travel damage — PHIX Doctor saves sessions worldwide.
          </p>
        </div>

        {/* Main testimonial */}
        <div className="max-w-3xl mx-auto mb-10">
          <div className="relative bg-[#143D35] rounded-3xl p-10 md:p-14">
            <div className="absolute top-8 left-10 text-[#FF6B35]/15 font-black text-[120px] leading-none select-none pointer-events-none">&ldquo;</div>
            <div className="relative z-10">
              <div className="flex gap-1 mb-6">
                {[1, 2, 3, 4, 5].map((s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400 text-base" />
                  </div>
                ))}
              </div>
              <p className="text-white text-xl md:text-2xl font-medium leading-relaxed mb-8">
                &ldquo;{testimonials[active].text}&rdquo;
              </p>
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[#FF6B35] flex-shrink-0">
                  <img
                    src={testimonials[active].avatar}
                    alt={testimonials[active].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-white font-bold">{testimonials[active].name}</p>
                  <p className="text-stone-400 text-sm">{testimonials[active].role} &middot; {testimonials[active].location}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Avatar selector */}
        <div className="flex items-center justify-center gap-3 flex-wrap mb-14">
          {testimonials.map((t, idx) => (
            <button
              key={t.id}
              onClick={() => setActive(idx)}
              className={`relative w-12 h-12 rounded-full overflow-hidden border-2 transition-all duration-200 cursor-pointer ${idx === active ? 'border-[#FF6B35] scale-110' : 'border-transparent opacity-50 hover:opacity-100'}`}
            >
              <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
            </button>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-[#1a4a40] pt-14">
          {[
            { value: '40K+', label: 'Surfers Worldwide' },
            { value: '60+', label: 'Countries' },
            { value: '4.9★', label: 'Average Rating' },
            { value: '1–3 min', label: 'Cure Time' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-[#FF6B35] font-black text-4xl mb-2">{stat.value}</p>
              <p className="text-stone-400 text-sm uppercase tracking-wider">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
